import { format } from "date-fns";

import { PhoneIcon, CalendarIcon } from "components/Icons";
import { cn } from "tools/ui";

const FORMAT = "dd.MMM.yyy";

const base =
  "bg-white m-1 pt-2 px-4 shadow-lg inline-block h-32 w-80 cursor-pointer rounded-2xl border border-white shadow-neutral-300 overflow-hidden active:scale-95 active:shadow-xl";
const divHead = "flex text-neutral-800 justify-between";
const divContent = "flex h-fit py-1 text-neutral-600 text-sm";

function CardGuest({ record, layout, onClick }) {
  const { card_action = [] } = layout;

  const key = record.id;

  let clickable = "";
  const selectable = card_action.includes("open");
  if (selectable) {
    clickable = "cursor-pointer active:scale-95 active:shadow-xl";
  }

  let actionDelete = false;
  if (card_action) {
    for (const action of card_action) {
      if (action === "delete") {
        actionDelete = true;
      }
    }
  }

  function handleClick(record) {
    onClick(record);
  }

  return (
    <div
      key={key}
      className={cn(base, clickable)}
      onClick={() => handleClick(record)}
    >
      <div className={divHead}>
        <div className="font-bold text-md truncate">{record.name}</div>
      </div>
      <div className={divContent}>
        <div id="left-section" className="w-1/2">
          <span className="text-neutral-400">
            {record.main_guest ? "Principal" : "Acompañante"}
          </span>
          <div className="flex text-sm mt-2">
            <span className="">
              {record.sex === "male" ? "Hombre" : "Mujer"}
            </span>
          </div>
          <div className="flex mt-2 my-1 text-sm">
            <span className="">{record.nationality.rec_name}</span>
          </div>
        </div>
        <div id="right-section" className="ml-2">
          <div className="font-bold text-neutral-500 mt-1">
            {record.type_guest === "adult" ? "Adulto" : "Niño"}
          </div>
          <div className="flex my-1 text-sm">
            <CalendarIcon className="h-4 text-neutral-600 my-auto fill-current" />
            <span className="">{format(record.birthday, FORMAT)}</span>
          </div>
          <div className="flex mt-2">
            <PhoneIcon className="h-5 text-cyan-400 my-auto fill-current" />
            <span className=" text-neutral-700 ml-2 text-sm">
              {record.mobile}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardGuest;
